module.exports = __webpack_public_path__ + "static/media/handoff-thanks-m.0791612f.png";